// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc } from '../../../../queries/fragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProductOfferingsOverviewPageQueryVariables = Types.Exact<{
  filter: Types.ProductOfferingsFilter;
  orderBy?: Types.InputMaybe<Types.ProductOfferingOrder>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type ProductOfferingsOverviewPageQuery = { __typename?: 'Query', productOfferings: { __typename?: 'ProductOfferingsPageResult', entities: Array<{ __typename?: 'ProductOffering', id: string, name: string, updatedAt: Types.Scalars['DateTime']['input'], showInCheckout: boolean, publishToUnderwriting: boolean, type: { __typename?: 'ReadyPlanTypeDetail', code: Types.ReadyPlanType, name: string }, effectiveStatus: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus }, canPublishToUnderwriting: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string }, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, canPublish: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined } | null | undefined, planPackage: { __typename?: 'PlanPackage', id: string, name: string }, planPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string }, interiorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, availableUpdates: Array<{ __typename?: 'DesignPackagePlanUpdate', id: string }> }, interiorDesignPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string }, exteriorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, availableUpdates: Array<{ __typename?: 'DesignPackagePlanUpdate', id: string }> }, exteriorDesignPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type ProductOfferingsOverviewTab_ProductOfferingFragment = { __typename?: 'ProductOffering', id: string, name: string, updatedAt: Types.Scalars['DateTime']['input'], showInCheckout: boolean, publishToUnderwriting: boolean, type: { __typename?: 'ReadyPlanTypeDetail', code: Types.ReadyPlanType, name: string }, effectiveStatus: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus }, canPublishToUnderwriting: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string }, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, canPublish: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined } | null | undefined, planPackage: { __typename?: 'PlanPackage', id: string, name: string }, planPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string }, interiorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, availableUpdates: Array<{ __typename?: 'DesignPackagePlanUpdate', id: string }> }, interiorDesignPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string }, exteriorDesignPackage: { __typename?: 'DesignPackage', id: string, name: string, availableUpdates: Array<{ __typename?: 'DesignPackagePlanUpdate', id: string }> }, exteriorDesignPackageVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } };

export type ProductOfferingsOverview_SaveProductOfferingMutationVariables = Types.Exact<{
  input: Types.SaveProductOfferingInput;
}>;


export type ProductOfferingsOverview_SaveProductOfferingMutation = { __typename?: 'Mutation', saveProductOffering: { __typename?: 'SaveProductOfferingResult', productOffering: { __typename?: 'ProductOffering', id: string, showInCheckout: boolean, publishToUnderwriting: boolean, canPublishToUnderwriting: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } } };

export const ProductOfferingsOverviewTab_ProductOfferingFragmentDoc = gql`
    fragment ProductOfferingsOverviewTab_ProductOffering on ProductOffering {
  id
  name
  type {
    code
    name
  }
  effectiveStatus {
    code
  }
  updatedAt
  showInCheckout
  publishToUnderwriting
  canPublishToUnderwriting {
    ...PotentialOperationDetails
  }
  coverAsset {
    id
    previewUrl(resizing: {width: 321, region: FULL})
  }
  aggregateLatest {
    id
    displayVersion
  }
  aggregateDraft {
    id
    canPublish {
      ...PotentialOperationDetails
    }
  }
  aggregateCheckout {
    id
    displayVersion
    promotedAt
  }
  planPackage {
    id
    name
  }
  planPackageVersion {
    id
    displayVersion
  }
  interiorDesignPackage {
    id
    name
    availableUpdates {
      id
    }
  }
  interiorDesignPackageVersion {
    id
    displayVersion
  }
  exteriorDesignPackage {
    id
    name
    availableUpdates {
      id
    }
  }
  exteriorDesignPackageVersion {
    id
    displayVersion
  }
}
    ${PotentialOperationDetailsFragmentDoc}`;
export const ProductOfferingsOverviewPageDocument = gql`
    query ProductOfferingsOverviewPage($filter: ProductOfferingsFilter!, $orderBy: ProductOfferingOrder, $page: PageFilter) {
  productOfferings(filter: $filter, orderBy: $orderBy, page: $page) {
    entities {
      ...ProductOfferingsOverviewTab_ProductOffering
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${ProductOfferingsOverviewTab_ProductOfferingFragmentDoc}`;

/**
 * __useProductOfferingsOverviewPageQuery__
 *
 * To run a query within a React component, call `useProductOfferingsOverviewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingsOverviewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingsOverviewPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useProductOfferingsOverviewPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductOfferingsOverviewPageQuery, ProductOfferingsOverviewPageQueryVariables> & ({ variables: ProductOfferingsOverviewPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOfferingsOverviewPageQuery, ProductOfferingsOverviewPageQueryVariables>(ProductOfferingsOverviewPageDocument, options);
      }
export function useProductOfferingsOverviewPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOfferingsOverviewPageQuery, ProductOfferingsOverviewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOfferingsOverviewPageQuery, ProductOfferingsOverviewPageQueryVariables>(ProductOfferingsOverviewPageDocument, options);
        }
// @ts-ignore
export function useProductOfferingsOverviewPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingsOverviewPageQuery, ProductOfferingsOverviewPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingsOverviewPageQuery, ProductOfferingsOverviewPageQueryVariables>;
export function useProductOfferingsOverviewPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingsOverviewPageQuery, ProductOfferingsOverviewPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingsOverviewPageQuery | undefined, ProductOfferingsOverviewPageQueryVariables>;
export function useProductOfferingsOverviewPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingsOverviewPageQuery, ProductOfferingsOverviewPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductOfferingsOverviewPageQuery, ProductOfferingsOverviewPageQueryVariables>(ProductOfferingsOverviewPageDocument, options);
        }
export type ProductOfferingsOverviewPageQueryHookResult = ReturnType<typeof useProductOfferingsOverviewPageQuery>;
export type ProductOfferingsOverviewPageLazyQueryHookResult = ReturnType<typeof useProductOfferingsOverviewPageLazyQuery>;
export type ProductOfferingsOverviewPageSuspenseQueryHookResult = ReturnType<typeof useProductOfferingsOverviewPageSuspenseQuery>;
export type ProductOfferingsOverviewPageQueryResult = ApolloReactCommon.QueryResult<ProductOfferingsOverviewPageQuery, ProductOfferingsOverviewPageQueryVariables>;
export const ProductOfferingsOverview_SaveProductOfferingDocument = gql`
    mutation ProductOfferingsOverview_SaveProductOffering($input: SaveProductOfferingInput!) {
  saveProductOffering(input: $input) {
    productOffering {
      id
      showInCheckout
      publishToUnderwriting
      canPublishToUnderwriting {
        ...PotentialOperationDetails
      }
    }
  }
}
    ${PotentialOperationDetailsFragmentDoc}`;

/**
 * __useProductOfferingsOverview_SaveProductOfferingMutation__
 *
 * To run a mutation, you first call `useProductOfferingsOverview_SaveProductOfferingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingsOverview_SaveProductOfferingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productOfferingsOverviewSaveProductOfferingMutation, { data, loading, error }] = useProductOfferingsOverview_SaveProductOfferingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductOfferingsOverview_SaveProductOfferingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProductOfferingsOverview_SaveProductOfferingMutation, ProductOfferingsOverview_SaveProductOfferingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProductOfferingsOverview_SaveProductOfferingMutation, ProductOfferingsOverview_SaveProductOfferingMutationVariables>(ProductOfferingsOverview_SaveProductOfferingDocument, options);
      }
export type ProductOfferingsOverview_SaveProductOfferingMutationHookResult = ReturnType<typeof useProductOfferingsOverview_SaveProductOfferingMutation>;
export type ProductOfferingsOverview_SaveProductOfferingMutationResult = ApolloReactCommon.MutationResult<ProductOfferingsOverview_SaveProductOfferingMutation>;